var dd = require('react-dd');
var FormInputMixin = require('../FormInputMixin');

var component = dd.createClass({
	mixins: [FormInputMixin],
	__onChange: function(e){
		this._input_newValue(e.target.value);
	},
	render: function(){
		var field = this.props.field;
		var value = this.props.value;

		if(field.read_only){
			return dd.p({className: 'form-control-static', style: {whiteSpace: 'pre-wrap'}},
				value
			);
		}

		return dd.textarea({
			rows: field.rows > 0 ? field.rows : 3,
			placeholder: field.placeholder || null,
			className: 'form-control',
			value: value || '',
			name: this.props.field_path,
			onChange: this.__onChange
		});
	}
});

module.exports = {
	component: component
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/forms/inputs/Textarea.js
// module id = 203
// module chunks = 0 1 2 3 4